import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";
import { SPECIALTIES } from "@/data/content";

export default function Specialties() {
  return (
    <section id="specialitati" className="py-20 lg:py-28 bg-[#FBF7EF]">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal className="max-w-2xl">
          <span className="text-xs font-semibold uppercase tracking-widest text-[#A6823B]">Specialități medicale</span>
          <h2 className="font-display text-3xl lg:text-4xl font-bold text-[#2A2521] mt-3">
            Douăsprezece specialități, un singur standard: excelența
          </h2>
          <p className="text-[#6B5C43] mt-4 text-lg">
            De la laboratorul propriu până la consultațiile de specialitate — fiecare detaliu este gândit în jurul tău.
          </p>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {SPECIALTIES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05} className={s.featured ? "sm:col-span-2 lg:row-span-2" : ""}>
              <Link to={`/specialitati/${s.slug}`} data-testid={`specialty-card-${s.id}`}
                className={`group h-full flex flex-col rounded-2xl border transition-all hover:-translate-y-1 ${
                  s.featured
                    ? "bg-[#2A2521] border-[#2A2521] text-white p-8 shadow-xl shadow-[#2A2521]/20"
                    : "bg-white border-[#EADFC6] p-6 hover:shadow-lg hover:border-[#A6823B]/40"
                }`}>
                <div className="flex items-start justify-between">
                  <span className={`w-12 h-12 rounded-xl flex items-center justify-center ${s.featured ? "bg-[#A6823B]/20" : "bg-[#EFE7D6]"}`}>
                    <s.icon className={`w-6 h-6 ${s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}`} />
                  </span>
                  <ArrowUpRight className={`w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity ${s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}`} />
                </div>
                <h3 className={`font-display font-bold mt-5 ${s.featured ? "text-2xl" : "text-lg text-[#2A2521]"}`}>{s.name}</h3>
                <p className={`mt-2 text-sm leading-relaxed flex-1 ${s.featured ? "text-white/75" : "text-[#8A7A5E]"}`}>{s.desc}</p>
                <span className={`mt-4 inline-flex items-center gap-1.5 text-sm font-semibold ${s.featured ? "text-[#DCC79A]" : "text-[#A6823B]"}`}>
                  Vezi detalii <ArrowUpRight className="w-4 h-4" />
                </span>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
